/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectDetailNotesController', ProjectDetailNotesController);

    ProjectDetailNotesController.$inject = ['entity', '$http'];

    function ProjectDetailNotesController(entity, $http) {
        var vm = this;
        vm.project = entity;
        vm.save = save;

        function save() {
            vm.isSaving = true;
            var projectNotesDTO = {
                id: vm.project.id,
                notes: vm.project.notes
            };
            $http.post('/api/projects/notes/', projectNotesDTO, null).then(onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.options = {
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['textsize', ['fontsize']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol']],
                ['view', ['codeview']]
            ]
        };
    }
})();
